import script from "./BasePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePopup.vue?vue&type=script&setup=true&lang=ts"

import "./BasePopup.vue?vue&type=style&index=0&id=7ae4a0b5&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae4a0b5"]])

export default __exports__